<template>
    <div>
        <PayAlert :isShow="isShow" @increase="getAlertState"/>
        <ContentHeader :disabled="false" :title="lang('singleLeftMenuText3_4',language)" :tip_text_arr="headerTipArr"/>
        <Card>
            <Spin size="large" fix v-if="boXueJiaLoading"></Spin>
            <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                {{lang('singleBoXueJiaPrimaryTitle',language)}}
            </p>
            <Row>
                <Col span="6" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('singleBoXueJiaTipTitle1',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{avgPassedPoints}}
                        <span :style="{fontSize:'18px'}">{{lang('singleBoXueJiaText1',language)}}</span>
                    </p>
                </Col>
                <Col span="6" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('singleBoXueJiaTipTitle2',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{totalStars}}
                        <span :style="{fontSize:'18px'}">{{lang('singleBoXueJiaText3',language)}}</span>
                    </p>
                </Col>
                <Col span="6" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('singleBoXueJiaTipTitle3',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{avgUsingTimePassed}}
                        <span :style="{fontSize:'18px'}">{{lang('singleBoXueJiaText5',language)}}</span>
                    </p>
                </Col>
                <Col span="6">
                    <p :style="{color: '#4F6B87'}">{{lang('singleBoXueJiaTipTitle4',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',fontSize: '36px',color:'#595959'}">
                        {{rightAnswerRate*100 | numFilter}}%
                    </p>
                </Col>
            </Row>
        </Card>
        <br/>

        <Row>
            <Col span="24">
                <SelectDate @increase="getDateRange"/>
                <Card>
                    <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                        {{lang('singleBoXueJiaText7',language)}}
                        <Checkbox style="margin-left: 50px" @on-change="checkRepeatSQ()" v-model="repeatSQ">{{lang('singleBoXueJiaText13',language)}}</Checkbox>
                    </p>

                    <div :style="{position:'relative'}">
                        <Spin fix v-if="boXueJiaLoading"></Spin>
                        <Table show-header border :columns="columnsArr" :data="dataArr"  v-if="userInfo.isSvip" ></Table>
                        <Table show-header border :columns="columnsArr" :data="dataArr"  v-else :span-method="handleSpan"></Table>
                    </div>
                    <br>
                    <Page :total="total" show-sizer show-total show-elevator @on-change="changePage"
                          :page-size-opts="[10, 20, 30, 40, 50]" :page-size="pageSize"
                          @on-page-size-change="changePageSize" placement="top" width="" v-if="dataArr.length>0" />
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
    var _hmt = _hmt || [];
    (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?4537bce4a2128c98b476fa3bc3b18f86";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
    })();

    import {lang} from "@/utils/language.js";
    import store from '@/store/index.js';
    import config from '@/utils/config.js';
    import ContentHeader from '@/components/ContentHeader.vue';
    import {getSingleData} from '@/utils/net.js';
    import SelectDate from '@/components/SelectDate.vue';
    import PayAlert from '@/components/PayAlert.vue';
    export default {
        name: "BoXueJia",
        store,
        components: {
            ContentHeader,
            SelectDate,
            PayAlert
        },
        data() {
            return {
                lang: lang,
                stateLang: '',
                headerTipArr: [],
                boXueJiaLoading:false,
                userId: '',
                avgPassedPoints: '',
                totalStars:'',
                avgUsingTimePassed:'',
                rightAnswerRate:'',
                start: '',
                end: '',
                total: 0,
                page: 1,
                pageSize: 10,
                columnsArr:[],
                dataArr:[],
                isShow:false,
                repeatSQ:true,
            }
        },
        mounted() {
            this.loadHeaderTipArr();
            this.getBoXueJiaTableTitleArr();
        },
        methods:{
            getAlertState(data){
                this.isShow = data
            },
            loadHeaderTipArr() {
                this.headerTipArr.splice(0);
                for (var i = 1; i <= 5; i++) {
                    var item = {};
                    item.title = this.lang('singleBoXueJiaTipTitle' + i, this.language);
                    item.content = this.lang('singleBoXueJiaTipContent' + i, this.language);
                    if (JSON.stringify(item) !== '') {
                        this.headerTipArr.push(item);
                    }
                }
            },

            handleSpan ({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 3) {
                    return [this.dataArr.length,1];
                }
            },


            /*获取表头数据*/
            getBoXueJiaTableTitleArr() {
                this.columnsArr.splice(0);
                for (let i = 1; i <= 4; i++) {
                    let item = {};
                    item.title = this.lang('singleBoXueJiaTableHeaderText' + i, this.language);
                    item.key = this.lang('singleBoXueJiaTableHeaderText' + i + '_key', this.language);
                    item.width = 200
                    if(item.key === 'answerDate'){
                        item.fixed = 'left'
                    }

                    if(item.key === 'rightAnswer' && !this.userInfo.isSvip){
                        item.align = 'center';
                        item.render = (h, params) => {
                            return h('div', [
                                h('p', {
                                    style: {
                                        marginBottom: '30px',
                                        fontWeight:'bold',
                                    },
                                }, this.lang('singleBoXueJiaText11',this.language)),
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'large'
                                    },
                                    on: {
                                        click: () => {
                                            this.isShow = true;
                                        }
                                    }
                                }, this.lang('singleBoXueJiaText9',this.language))
                            ]);
                        }
                    }
                    this.columnsArr.push(item);
                }
            },


            getBoXueJiaDaily() {
                let that = this;
                that.boXueJiaLoading = true;
                getSingleData({
                    context: that,
                    url: '/open/rfunc/qgame/waq/person',
                    params: {
                        start: that.start,
                        end: that.end,
                        page: that.page,
                        pageSize: that.pageSize,
                        repeatSQ:that.repeatSQ,
                        de: config.de
                    },
                    onCallBack: function (retMap) {
                        that.avgPassedPoints = retMap.primary.avgPassedPoints;
                        that.totalStars = retMap.primary.totalStars;
                        that.avgUsingTimePassed = retMap.primary.avgUsingTimePassed;
                        that.rightAnswerRate = retMap.primary.rightAnswerRate;
                        that.total = retMap.total;
                        that.dataArr = retMap.list;
                        that.boXueJiaLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.boXueJiaLoading = false;
                    }
                })
            },
            getDateRange(data) {
                this.start = data.t2;
                this.end = data.t1;
                this.getBoXueJiaDaily();
            },
            changePage(page) {
                this.page = page;
                this.getBoXueJiaDaily();
            },
            changePageSize(pageSize) {
                this.pageSize = pageSize;
                this.getBoXueJiaDaily();
            },
            checkRepeatSQ(){
                this.getBoXueJiaDaily();
            }


        },
        computed: {
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            },
            userInfo: function () {
                return store.getters.getUser;
            }
        },
        watch: {
            stateLang: function () {

            }
        },
        filters: {
            numFilter(value) {
                // 截取当前数据到小数点后两位
                let realVal = parseFloat(value).toFixed(2);
                // num.toFixed(2)获取的是字符串
                return parseFloat(realVal);
            }
        }
    }
</script>
<style scoped>

</style>
